// Central place to edit business contact details.
export const SITE = {
  brand: "MyPT",
  tagline: "My Personal Trainer",
  phoneDisplay: "07456 717115",
  phoneRaw: "+447456717115",
  email: "info@stmypt.com",
  whatsapp: "447456717115", // digits only, country code, no +
  domain: "stmypt.com",
  area: "Chelmsford & across Essex",
  instagram: "https://instagram.com/stmypt",
  facebook: "https://facebook.com/stmypersonaltrainer",
  logo: "/logo.png",
  towns: [
    "Chelmsford", "Braintree", "Great Dunmow", "Witham", "Maldon",
    "Billericay", "Chipping Ongar", "Wickford", "Rayleigh", "Basildon",
    "Brentwood", "South Woodham Ferrers", "Canvey Island", "Loughton",
  ],
};

export const IMAGES = {
  hero: "https://images.pexels.com/photos/6551283/pexels-photo-6551283.jpeg",
  home: "https://images.unsplash.com/photo-1758599880336-ac6f4cb7f204",
  garage: "https://images.pexels.com/photos/38965744/pexels-photo-38965744.jpeg",
  inclusive: "https://images.pexels.com/photos/7551627/pexels-photo-7551627.jpeg",
  nutrition: "https://images.pexels.com/photos/4929677/pexels-photo-4929677.jpeg",
  park: "https://images.pexels.com/photos/6551283/pexels-photo-6551283.jpeg",
  workplace: "https://images.unsplash.com/photo-1758611972534-4436e3cc719e",
};
